import {
  AngleSliderProps as MantineAngleSliderProps,
  AngleSlider as MantineAngleSlider,
} from '@mantine/core';

export type AngleSliderProps = MantineAngleSliderProps;

export const AngleSlider = MantineAngleSlider;

AngleSlider.displayName = 'AngleSlider';
